
import ProductNewComponent from "../../../components/products/New.vue";

export default {
  components: {
    ProductNewComponent,
  },
};
